import DbConfig from '../../../config/DbConfig.js'

// 删除所有的数据表
export function dropTable(callback){
	let promise = Promise.resolve();
	let db = DbConfig.connect();
	let tables = [
		"yswl_custom",
		"yswl_custom_friends",
		"yswl_custom_friends_tags",
		"yswl_custom_friends_type",
		"yswl_recently",
		"yswl_chat_record",
		"yswl_cluster",
		"yswl_cluster_chat_record",
		"yswl_cluster_member"
	];
	for (let i = 0; i < tables.length; i++) {
		promise = promise.then((response)=>{
			return new Promise((resolve, reject)=>{
				db.transaction(tx=>{
					tx.executeSql('drop table '+tables[i],[],(tx,results)=>{
						resolve();
					});
				});
			});
		});
	}
	promise.then((response)=>{
		callback()
	})
}

// 清除本地数据，重置同步id
export function clearTable(clearList,callback){
	let promise = Promise.resolve()
	let db = DbConfig.connect()
	let tables = {
		fans: {
			table: "yswl_custom_friends",
			syncField: "async_fans_id" 
		},
		recently: {
			table: "yswl_recently",
			syncField: "async_recent_id" 
		},
		record: {
			table: "yswl_chat_record",
			syncField: "async_chat_id" 
		},
		tags: {
			table: "yswl_custom_friends_tags",
			syncField: "async_fans_tag_id" 
		}
	}
	for (let i = 0; i < clearList.length; i++) {
		promise = promise.then((response)=>{
			return new Promise((resolve, reject)=>{
				db.transaction(tx=>{
					tx.executeSql('delete from '+tables[clearList[i]].table,[],(tx,results)=>{
						tx.executeSql('update yswl_custom set ' + tables[clearList[i]].syncField + ' = 0',[],(tx,results)=>{
							resolve()
						})
					})
				})
			})
		})
	}
	promise.then((response)=>{
		callback()
	})
}